module.exports = __webpack_public_path__ + "assets/img/ts-2-light.12d214de.png";